function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { UnstyledTag } from "../../unstyled/tag/UnstyledTag";
import "./tag.css";
/**
 * An unstyled Tag component.
 *
 * Props:
 * - label: (string) The text content of the tag.
 * - onClick: (function) The function to call when the tag is clicked. (optional)
 * - ...rest: (props) Additional props to be passed to the underlying HTML element.
 */

const Tag = ({
  classPrepend = 'styled',
  label = "",
  closable = false,
  onClose = null,
  icon = null,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(UnstyledTag, _extends({
    classPrepend: classPrepend,
    label: label,
    closable: closable,
    onClose: onClose
  }, rest));
};
export { Tag };